import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import Stepper from '../questionnaire/Stepper';
import {
  COLOR_DENIM,
  COLOR_HUMMINGBIRD,
  COLOR_WHITE,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_SEMI_BOLD,
} from 'popTheme';
import { selectCRAFFTScore } from 'redux/checkIn/selectors';
import { useSelector } from 'react-redux';

const AssessmentActions = ({ activeStep, blurb, buttonText, onClick }) => {
  const crafftScore = useSelector(selectCRAFFTScore);

  return (
    <Grid container direction="column" sx={style.container} data-testid="assessment-actions">
      <Typography variant="h4" sx={style.blurb}>
        {blurb}
      </Typography>
      {buttonText && (
        <Button variant="contained" onClick={onClick} sx={style.buttonCaption}>
          {buttonText}
        </Button>
      )}
      {activeStep > 0 && (
        <Grid item sx={style.item}>
          <Stepper activeStep={activeStep} maxSteps={crafftScore > 0 ? 32 : 24} />
        </Grid>
      )}
    </Grid>
  );
};

export default AssessmentActions;

const style = {
  container: {
    minHeight: '42rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  item: {
    position: 'relative',
    top: '12rem',
  },
  blurb: {
    color: COLOR_WHITE,
    fontWeight: FONT_WEIGHT_BOLD,
    textAlign: 'center',
    px: '2.375rem',
    pb: '2.375rem',
  },
  buttonCaption: {
    background: COLOR_HUMMINGBIRD,
    width: 'auto',
    minWidth: '6.75rem',
    height: '2.75rem',
    borderRadius: '0.375rem',
    color: COLOR_DENIM,
    fontWeight: FONT_WEIGHT_SEMI_BOLD,
    px: '0.625rem',
    py: '1.5rem',
  },
};
